export default __webpack_public_path__ + "static/media/Honored Fauld of the Mound.8e271ca8.jpg";